module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowMedium.d5633e4.ttf";